import { useState } from 'react';
import type { TwoFactorSetupCompletionResponse } from '@/shared/api';
import { useAuth } from '@/shared/auth';

export function useRecoveryCodes() {
  const acceptSession = useAuth().acceptSession;
  const [recoveryCodes, setRecoveryCodes] = useState<string[] | null>(null);
  const [sessionFailure, setSessionFailure] = useState<string | null>(null);
  const receive = async (result: TwoFactorSetupCompletionResponse) => {
    // Der Server zeigt die Codes nur einmal; eine fehlgeschlagene Sitzungsübernahme darf sie nicht verlieren.
    setRecoveryCodes(result.recoveryCodes);
    setSessionFailure(null);
    try {
      await acceptSession(result);
    } catch {
      setSessionFailure(
        'Die Codes wurden erstellt, aber die Sitzung ließ sich nicht erneuern. Sichere die Codes und melde dich danach neu an.',
      );
    }
  };
  const clear = () => {
    setRecoveryCodes(null);
    setSessionFailure(null);
  };
  return { recoveryCodes, sessionFailure, receive, clear };
}
